import { memo } from 'react'
import { actionButtonsStyles as styles } from './ActionButtons.style'
import { SxProps } from '@mui/material'
import { ActionButtonProps } from './ActionButtons.types'
import { actionButtonClasses } from './ActionButtons.data'
import { Box } from '@/components/Layout'
import Button from '../Button'

function ActionButtons({
  primaryActionText,
  onPrimaryActionClick,
  secondaryActionText,
  onSecondaryActionClick,
  fixedInMobile = false,
  bordered = false,
  topBordered = false,
  largePrimaryButton = false,
  wrapperProps = {},
  primaryButtonProps = {},
  secondaryButtonProps = {},
}: ActionButtonProps) {
  const { sx: wrapperSx = {}, ...restWrapperProps } = wrapperProps
  const { sx: primaryButtonSx = {}, ...restPrimaryButtonProps } = primaryButtonProps
  const { sx: secondaryButtonSx = {}, ...restSecondaryButtonProps } = secondaryButtonProps
  return (
    <Box
      sx={{ ...styles.wrapper, ...wrapperSx } as SxProps}
      className={`${fixedInMobile ? actionButtonClasses.fixedInMobile : ''} ${bordered ? actionButtonClasses.bordered : ''} ${topBordered ? actionButtonClasses.topBordered : ''}`}
      {...restWrapperProps}>
      {primaryActionText && (
        <Button
          size="large"
          sx={
            {
              ...styles.button,
              ...(largePrimaryButton ? styles.buttonLarge : {}),
              ...primaryButtonSx,
            } as SxProps
          }
          onClick={onPrimaryActionClick}
          {...restPrimaryButtonProps}>
          {primaryActionText}
        </Button>
      )}

      {secondaryActionText && (
        <Button
          color="tertiary"
          size="large"
          sx={{ ...styles.button, ...styles.buttonSecondary, ...secondaryButtonSx } as SxProps}
          onClick={onSecondaryActionClick}
          {...restSecondaryButtonProps}>
          {secondaryActionText}
        </Button>
      )}
    </Box>
  )
}

export default memo(ActionButtons)
